import PropTypes from 'prop-types'

import ColumnGridPanel from 'components/ColumnGridPanel'

import { degrees, percentage, staticPressure } from 'helpers/formatters'

const propTypes = {
  report: PropTypes.shape().isRequired
}

const defaultProps = {
  report: {}
}

const ZoningInfo = ({ report }) => {
  const zoneReport = {
    staticPressure: staticPressure(report.staticPressure / 100),
    dischargeAirTemperature: report.deviceType === 'thermostat' ? degrees(report.dischargeAirTemperature, 1) : null,
    returnAirTemperature: report.deviceType === 'thermostat' ? degrees(report.returnAirTemperature, 1) : null,
    excessAirPercentage: percentage(report.excessAirPercentage, 1)
  }

  const hasData = Object.values(zoneReport).some(val => val !== null)
  if (!hasData) {
    return null
  }

  return (
    <ColumnGridPanel.Column>
      <ColumnGridPanel.Column.Header>Zoning Info</ColumnGridPanel.Column.Header>

      <ColumnGridPanel.Column.Item label="Static Pressure" value={zoneReport.staticPressure} hideIfValueIsNull />

      {
        report.deviceType === 'thermostat' &&
          <ColumnGridPanel.Column.Item label="Discharge Temp" value={zoneReport.dischargeAirTemperature} hideIfValueIsNull />
      }
      {
        report.deviceType === 'thermostat' &&
          <ColumnGridPanel.Column.Item label="Return Air Temp" value={zoneReport.returnAirTemperature} hideIfValueIsNull />
      }

      <ColumnGridPanel.Column.Item label="Excess Air" value={zoneReport.excessAirPercentage} hideIfValueIsNull />
    </ColumnGridPanel.Column>
  )
}

ZoningInfo.propTypes = propTypes
ZoningInfo.defaultProps = defaultProps

export default ZoningInfo
